import { quickLoginErrorCodes } from './quick-login-error-codes.js';

export const AUTH_INVALID_CREDENTIALS = 'AUTH_INVALID_CREDENTIALS';
export const AUTH_USER_DISABLED = 'AUTH_USER_DISABLED';
export const AUTH_TOKEN_INVALID = 'AUTH_TOKEN_INVALID';
export const AUTH_TOKEN_EXPIRED = 'AUTH_TOKEN_EXPIRED';
export const AUTH_EMAIL_ALREADY_EXISTS = 'AUTH_EMAIL_ALREADY_EXISTS';
export const AUTH_SESSION_INVALID = 'AUTH_SESSION_INVALID';
export const AUTH_SESSION_REVOKED = 'AUTH_SESSION_REVOKED';
export const AUTH_SESSION_SCOPE_REQUIRED = 'AUTH_SESSION_SCOPE_REQUIRED';
export const AUTH_SESSION_SCOPE_MISMATCH = 'AUTH_SESSION_SCOPE_MISMATCH';
export const AUTH_STATION_SYNC_REAUTH_REQUIRED = 'AUTH_STATION_SYNC_REAUTH_REQUIRED';
export const AUTH_STATION_SYNC_BINDING_INVALID = 'AUTH_STATION_SYNC_BINDING_INVALID';
export const AUTH_STATION_SYNC_PROFILE_MISMATCH = 'AUTH_STATION_SYNC_PROFILE_MISMATCH';
export const AUTH_STATION_SYNC_PERSISTENCE_REQUIRED = 'AUTH_STATION_SYNC_PERSISTENCE_REQUIRED';
export {
  AUTH_QUICK_LOGIN_PROFILE_NOT_ELIGIBLE,
  AUTH_QUICK_LOGIN_PIN_NOT_SET,
  AUTH_QUICK_LOGIN_PIN_INVALID,
  AUTH_QUICK_LOGIN_PIN_LOCKED,
  AUTH_QUICK_LOGIN_STEP_UP_REQUIRED,
  AUTH_QUICK_LOGIN_STEP_UP_INVALID,
  AUTH_QUICK_LOGIN_PASSWORD_VERIFIER_MISSING,
  AUTH_QUICK_LOGIN_PIN_POLICY_VIOLATION,
  AUTH_QUICK_LOGIN_ADMIN_REQUIRED,
  AUTH_QUICK_LOGIN_CURRENT_PIN_REQUIRED,
} from './quick-login-error-codes.js';

export const authErrorCodes = [
  AUTH_INVALID_CREDENTIALS,
  AUTH_USER_DISABLED,
  AUTH_TOKEN_INVALID,
  AUTH_TOKEN_EXPIRED,
  AUTH_EMAIL_ALREADY_EXISTS,
  AUTH_SESSION_INVALID,
  AUTH_SESSION_REVOKED,
  AUTH_SESSION_SCOPE_REQUIRED,
  AUTH_SESSION_SCOPE_MISMATCH,
  AUTH_STATION_SYNC_REAUTH_REQUIRED,
  AUTH_STATION_SYNC_BINDING_INVALID,
  AUTH_STATION_SYNC_PROFILE_MISMATCH,
  AUTH_STATION_SYNC_PERSISTENCE_REQUIRED,
  ...quickLoginErrorCodes,
] as const;

export type AuthErrorCode = (typeof authErrorCodes)[number];
